<ul class="subcategory-grid">
  @for (subcategory of groups(); track subcategory.id) {
    <li class="subcategory-group">
      <a
        class="subcategory-link"
        routerLink="/products"
        [queryParams]="{ category: subcategory.id }"
        queryParamsHandling="replace"
        (click)="navigated.emit()">
        @if (subcategory.media) {
          <img [ngSrc]="subcategory.media | smallestThumbnail" width="48" height="48" alt="" />
        }
        <span>{{ subcategory.name }}</span>
      </a>
      @if (subcategory.children.length) {
        <ng-container *ngTemplateOutlet="descendants; context: { $implicit: subcategory.children }" />
      }
    </li>
  }
</ul>

<ng-template #descendants let-categories>
  <ul class="descendant-list">
    @for (category of categories; track category.id) {
      <li>
        <a routerLink="/products" [queryParams]="{ category: category.id }" queryParamsHandling="replace" (click)="navigated.emit()">
          {{ category.name }}
        </a>
        @if (category.children.length) {
          <ng-container *ngTemplateOutlet="descendants; context: { $implicit: category.children }" />
        }
      </li>
    }
  </ul>
</ng-template>
